import { yup } from "@swa-ui/object";

export const WHEELCHAIR_OPTIONS = {
  MANUAL_WHEELCHAIR: "manualWheelchair",
  NO_WHEELCHAIR_STOWAGE: "noWheelchairStowage",
  WITH_NON_SPILLABLE_BATTERIES: "wheelchairWithNonSpillableBatteries",
  WITH_REMOVABLE_BATTERIES: "wheelchairWithRemovableBatteries",
  WITH_SPILLABLE_BATTERIES: "wheelchairWithSpillableBatteries",
};

export const PERSONAL_WHEELCHAIR_ASSISTANCE_SCHEMA_FIELD_NAMES = {
  NON_SPILLABLE_BATTERIES_COUNT: "nonSpillableBatteries",
  REMOVABLE_BATTERIES_COUNT: "removableBatteries",
  SPILLABLE_BATTERIES_COUNT: "spillableBatteries",
  WHEELCHAIR_STOWAGE: "wheelchairStowage",
};

export const getPersonalWheelchairAssistanceFormFieldsSchema = (fieldNames = {}) => {
  const {
    NON_SPILLABLE_BATTERIES_COUNT,
    REMOVABLE_BATTERIES_COUNT,
    SPILLABLE_BATTERIES_COUNT,
    WHEELCHAIR_STOWAGE,
  } = PERSONAL_WHEELCHAIR_ASSISTANCE_SCHEMA_FIELD_NAMES;
  const {
    nonSpillableBatteries = NON_SPILLABLE_BATTERIES_COUNT,
    removableBatteries = REMOVABLE_BATTERIES_COUNT,
    spillableBatteries = SPILLABLE_BATTERIES_COUNT,
    wheelchairStowage = WHEELCHAIR_STOWAGE,
  } = fieldNames;

  return {
    [nonSpillableBatteries]: yup.number().when(wheelchairStowage, {
      is: (value) => value === WHEELCHAIR_OPTIONS.WITH_NON_SPILLABLE_BATTERIES,
      otherwise: yup.number(),
      then: yup.number().required(),
    }),
    [removableBatteries]: yup.number().when(wheelchairStowage, {
      is: (value) => value === WHEELCHAIR_OPTIONS.WITH_REMOVABLE_BATTERIES,
      otherwise: yup.number(),
      then: yup.number().required(),
    }),
    [spillableBatteries]: yup.number().when(wheelchairStowage, {
      is: (value) => value === WHEELCHAIR_OPTIONS.WITH_SPILLABLE_BATTERIES,
      otherwise: yup.number(),
      then: yup.number().required(),
    }),
    [wheelchairStowage]: yup.string(),
  };
};
